import React, { useEffect } from 'react'

import useCurrentUser from "../../../components/platform/hooks/useCurrentUser";
import apiClient from "../../../services/axios";
import {ItemCode} from "../../models/ItemCode";
import {getUrl} from "../../../services/api";

const defaultState = {
  itemCodes: {},
  itemCodesById: {},
  loading: true
}

type itemCodesContectType = typeof defaultState

export const ItemCodeContext = React.createContext({} as itemCodesContectType)

const reducer = (state: any, action: any) => {
  switch (action.type) {
    case 'set':
      return {
        ...state,
        ...action.payload
      }
    default:
      return state
  }
}

export const ItemCodeContextProvider = ({ children }: any) => {
  const currentUser = useCurrentUser()
  const [state, dispatch] = React.useReducer(reducer, defaultState)


  useEffect(()=> {
    let isMounted = true
    
    if(currentUser?.authorized) {
      // '/api/item_code_views'
      apiClient.get(getUrl("/api/item_codes"), {
        params: {
          pagination: false,
          lang: currentUser?.locale || 'en',
          notTypes: [
            "tvl_region",
            "tvl_sector",
            "tvl_function",
            "tvl_position",
            "tvl_experience",
            "tvl_study",
            "tvl_level"
          ]
        },
        // responseType: 'application/json'
        headers: {
          'Accept': 'application/json'
        }
      }).then(({data: hdata}) => {
        if (!isMounted) return
        
        const data = hdata['hydra:member'];
        const reduced = data.reduce((acc: any, item: any) => {
          item['@id'] = `/api/item_codes/${item.id}`

          acc.itemCodes[item.tipo] = acc.itemCodes[item.tipo] || [];
          acc.itemCodes[item.tipo].push(item);

          acc.itemCodesById[item['@id']] = item;
          return acc;
        }, {
          itemCodes: {},
          itemCodesById: {},
        });


        dispatch({
          type: 'set',
          payload: {
            loading: false,
            ...reduced
          }
        })
      }).catch(() => {
        if (isMounted) {
          dispatch({
            type: 'set',
            payload: { loading: false }
          })
        }
      })
    }
    
    return () => {
      isMounted = false
    }
  },[currentUser?.authorized, currentUser?.locale])

  return (
    <ItemCodeContext.Provider value={state}>
      {children}
    </ItemCodeContext.Provider>
  )
}



export const useItemCodes = (types?: string[] | undefined) => {
  const {itemCodes} = React.useContext<itemCodesContectType>(ItemCodeContext)
  // console.log(`itemCodes2 ${types}`)

  const data = React.useMemo(() => {
    return types?.reduce((acc:any, type:string) => {
      acc[type] = itemCodes[type];
      return acc;
    },{})
  }, [itemCodes, types])

  return {
    itemCodes: data,
    loading: false
  }
}

export const useItemCodeByIris = (iris: string): ItemCode | null => {
  const {itemCodesById} = React.useContext<itemCodesContectType>(ItemCodeContext)
  return itemCodesById[iris] || null
}
